import React from "react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetFooter,
  Button,
} from "lift-ui";

export interface StationFile {
  id?: string;
  buddy_id: string;
  agent_id?: string; // legacy field
  file_id: string;
  file_name: string;
  version: number;
  is_active: boolean;
  uploaded_at?: string;
  created_at?: string;
  updated_at?: string;
  file_size?: number;
  children?: StationFile[];
}

interface ViewFileDialogProps {
  open: boolean;
  onClose: () => void;
  file: StationFile | null;
}

const ViewFileDialog: React.FC<ViewFileDialogProps> = ({ open, onClose, file }) => {
  return (
    <Sheet open={open} onOpenChange={onClose}>
      <SheetContent side="right" className="w-[500px] sm:max-w-[500px] flex flex-col">
        <SheetHeader>
          <SheetTitle>File Details</SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto py-6 space-y-4">
          <div>
            <p className="text-sm text-gray-600">File details dialog under development.</p>
            {file && <p className="mt-2 text-base">File: {file.file_name}</p>}
          </div>
        </div>
        <SheetFooter className="border-t pt-4 mt-4">
          <Button onClick={onClose}>Close</Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
};

export default ViewFileDialog;
